import WordmarkLogo from "@/components/wynn/WordmarkLogo";

const LOGO =
  "https://customer-assets.emergentagent.com/job_five-min-formula/artifacts/xl70jip2_WYNN%20%282%29.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="wynn-footer"
      className="relative bg-[#070608] border-t border-[#F4F1EC]/10"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-10 items-start">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-3">
              <img src={LOGO} alt="" aria-hidden className="h-10 w-auto select-none" draggable="false" />
              <WordmarkLogo height={28} />
            </div>
            <p className="mt-5 font-body text-sm text-[#F4F1EC]/60 max-w-md leading-relaxed">
              A pocket companion for the inner artist. Built by hand, slowly, for
              creators who already carry enough noise in a day.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#F4F1EC]/45 font-body">
              Explore
            </div>
            <ul className="mt-4 space-y-3 font-body text-sm text-[#F4F1EC]/80">
              <li><a href="#studio" className="hover:text-[#FFB7C6] transition-colors">The practice</a></li>
              <li><a href="#features" className="hover:text-[#FFB7C6] transition-colors">Inside the app</a></li>
              <li><a href="#founder" className="hover:text-[#FFB7C6] transition-colors">The maker</a></li>
              <li><a href="#faq" className="hover:text-[#FFB7C6] transition-colors">Questions</a></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#F4F1EC]/45 font-body">
              The studio
            </div>
            <ul className="mt-4 space-y-3 font-body text-sm text-[#F4F1EC]/80">
              <li>hello@wynn.art</li>
              <li>iOS first · 2026</li>
              <li>For quiet creators</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#F4F1EC]/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="font-body text-xs text-[#F4F1EC]/45">
            © {year} WYNN. Made in a quiet room.
          </div>
          <div className="font-body text-[10px] uppercase tracking-[0.3em] text-[#F4F1EC]/45">
            Creative transformation, in your pocket
          </div>
        </div>
      </div>
    </footer>
  );
}
